import type { FC } from 'react';

import { Box, StaticDateSpan, StaticTimeSpan, Typography } from '@myn/mui';

type Props = {
  label: string;
  date: Date;
};

const DateTime: FC<Props> = ({ label, date }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography variant="bodyShort01" color="text.secondary">
        {label}:
      </Typography>
      <Typography variant="bodyShort01" color="text.primary">
        <StaticDateSpan date={date} />
        {' - '}
        <StaticTimeSpan date={date} />
      </Typography>
    </Box>
  );
};

export default DateTime;
